// extracted by mini-css-extract-plugin
export default {"scrollContainer":"InvoiceOrdersGrid_scrollContainer__5jI9B"};